import Cookies from "js-cookie";

const TokenKey = "TOKEN";
const UserKey = "USER";

/**
 *
 * @returns
 */
export function getToken() {
  // console.log("Getting token", Cookies.get(TokenKey));
  return Cookies.get(TokenKey);
}

export function getUser() {
  const user = Cookies.get(UserKey);
  if (user) return JSON.parse(Cookies.get(UserKey));
  return false;
}

/**
 *
 * @param {*} value
 * @returns
 */
export function setToken(value, duration = 0) {
  // console.log("Setting token", value);
  if (duration <= 0) return Cookies.set(TokenKey, value);
  return Cookies.set(TokenKey, value, { expires: duration });
}

export function setUser(value, duration = 0) {
  if (duration <= 0) return Cookies.set(UserKey, JSON.stringify(value));
  return Cookies.set(TokenKey, JSON.stringify(value), { expires: duration });
}

/**
 *
 * @returns
 */
export function removeToken() {
  return Cookies.remove(TokenKey);
}
